import { MainCard } from "../../../components/Card/Cards";
import {
  CustomCalenderInput,
  CustomInput,
  CustomTextArea,
} from "../../../components/Input/input";
import { Button } from "primereact/button";
import { InputSwitch } from "primereact/inputswitch";
import React, { useRef, useState } from "react";
import { Toast } from "primereact/toast";
import axios from "axios";
import { API_BASE_URL } from "../../../utils/constants";
export default function EmploymentHistory({ step, setStep }) {
  const toast = useRef(null);
  const [employer, setEmployer] = useState([
    {
      name: "",
      address: "",
      contactPerson: "",
      typeOfEquipmentDrive: "",
      fmcsrs: "",
      position: false,
      from: "",
      to: "",
      reason: "",
      saftySenstive: false,
      drugAlcohol: false,
    },
  ]);

  const employerObj = {
    name: "",
    address: "",
    contactPerson: "",
    typeOfEquipmentDrive: "",
    fmcsrs: "",
    position: false,
    from: "",
    to: "",
    reason: "",
    saftySenstive: false,
    drugAlcohol: false,
  };

  const handleChange = ({ name, value, index }) => {
    setEmployer((prev) =>
      prev?.map((item, i) => (i === index ? { ...item, [name]: value } : item))
    );
  };

  const addAnotherEmployer = () => {
    let lastEmployer = employer[employer?.length - 1];
    if (
      lastEmployer.name !== "" ||
      lastEmployer.address !== "" ||
      lastEmployer.contactPerson !== "" ||
      lastEmployer.from !== "" ||
      lastEmployer.to !== ""
    ) {
      setEmployer((prev) => [...prev, employerObj]);
    } else
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Please fill all required fields",
      });
  };

  const submitData = async () => {
    let lastEmployer = employer[employer?.length - 1];
    if (
      lastEmployer.name !== "" ||
      lastEmployer.address !== "" ||
      lastEmployer.contactPerson !== "" ||
      lastEmployer.from !== "" ||
      lastEmployer.to !== ""
    ) {
      try {
        const token = sessionStorage.getItem("token"); // Retrieve token from sessionStorage

        console.log("token", token);
        const response = await axios.post(
          API_BASE_URL + "/api/driver/employment-history",
          { employmentHistory: employer, authToken: token },
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the token in the Authorization header
            },
          }
        );
        console.log(response);
        setStep((prev) => prev + 1);
      } catch (err) {
        alert(err.response?.data?.message || "Failed to save information");
      }
    } else
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Please fill all required fields",
      });
  };

  return (
    <MainCard size="container">
      <Toast ref={toast} />
      <p>
        All driver applicants to drive a commercial motor vehicle in interstate
        or intrastate commerce shall provide information on all employers during
        the preceding 10 years. Gaps in Employment Must be accounted for with
        explanation. Please list all employers in reverse order, starting with
        the most recent.
      </p>
      {employer?.map((obj, index) => (
        <div className="flex flex-wrap" key={index}>
          <h3 className="w-full pl-2">Employer {index + 1}</h3>
          <CustomInput
            label="Name"
            required
            name="name"
            value={obj?.name}
            onChange={({ name, value }) => handleChange({ name, value, index })}
          />
          <CustomInput
            label="Contact Person"
            required
            name="contactPerson"
            value={obj?.contactPerson}
            onChange={({ name, value }) => handleChange({ name, value, index })}
          />
          <CustomTextArea
            label="Address"
            required
            name="address"
            value={obj?.address}
            onChange={({ name, value }) => handleChange({ name, value, index })}
          />
          <CustomCalenderInput
            label="From"
            required
            name="from"
            value={obj?.from}
            onChange={({ name, value }) => handleChange({ name, value, index })}
          />
          <CustomCalenderInput
            label="To"
            required
            name="to"
            value={obj?.to}
            onChange={({ name, value }) => handleChange({ name, value, index })}
          />
          <CustomInput
            label="Type of Equipment Driven"
            name="typeOfEquipmentDrive"
            value={obj?.typeOfEquipmentDrive}
            onChange={({ name, value }) => handleChange({ name, value, index })}
          />
          <CustomInput
            label="Reason for leaving"
            name="reason"
            value={obj?.reason}
            onChange={({ name, value }) => handleChange({ name, value, index })}
          />
          <div className="pl-2 col-4">
            <p>Position Held -</p>
            <div className="flex align-items-center gap-3 pl-1">
              <span className={!obj?.position ? "font-semibold" : ""}>
                Salary
              </span>
              <InputSwitch
                checked={obj?.position}
                onChange={(e) =>
                  setEmployer((prev) =>
                    prev?.map((item) =>
                      item?.id === obj?.id
                        ? { ...item, position: e?.value }
                        : item
                    )
                  )
                }
              />
              <span className={obj?.position ? "font-semibold" : ""}>Wage</span>
            </div>
          </div>
          <div className="pl-2 col-4">
            <p>Was this safety sensitive position -</p>
            <div className="flex align-items-center gap-3 pl-1">
              <span className={!obj?.saftySenstive ? "font-semibold" : ""}>
                No
              </span>
              <InputSwitch
                checked={obj?.saftySenstive}
                onChange={(e) =>
                  setEmployer((prev) =>
                    prev?.map((item) =>
                      item?.id === obj?.id
                        ? { ...item, saftySenstive: e?.value }
                        : item
                    )
                  )
                }
              />
              <span className={obj?.saftySenstive ? "font-semibold" : ""}>
                Yes
              </span>
            </div>
          </div>
          <div className="pl-2 col-4">
            <p>Were you subject to Drug & Alcohol testing -</p>
            <div className="flex align-items-center gap-3 pl-1">
              <span className={!obj?.drugAlcohol ? "font-semibold" : ""}>
                No
              </span>
              <InputSwitch
                checked={obj?.drugAlcohol}
                onChange={(e) =>
                  setEmployer((prev) =>
                    prev?.map((item) =>
                      item?.id === obj?.id
                        ? { ...item, drugAlcohol: e?.value }
                        : item
                    )
                  )
                }
              />
              <span className={obj?.drugAlcohol ? "font-semibold" : ""}>
                Yes
              </span>
            </div>
          </div>
          <div className="pl-2 col-12">
            <p>Were you subject to the FMCSRs** while employed? </p>
            <div className="flex align-items-center gap-3 pl-1">
              <span className={!obj?.fmcsrs ? "font-semibold" : ""}>No</span>
              <InputSwitch
                checked={obj?.fmcsrs}
                onChange={(e) =>
                  setEmployer((prev) =>
                    prev?.map((item) =>
                      item?.id === obj?.id
                        ? { ...item, fmcsrs: e?.value }
                        : item
                    )
                  )
                }
              />
              <span className={obj?.fmcsrs ? "font-semibold" : ""}>Yes</span>
            </div>
          </div>

          {index !== employer?.length - 1 && <hr className="w-full m-5" />}
        </div>
      ))}
      <div className="flex justify-content-end mt-4 pr-2 gap-3">
        <Button
          label="Add Another Employer"
          severity="secondary"
          onClick={addAnotherEmployer}
        />
        <Button label="Save & Continue" onClick={submitData} />
      </div>
    </MainCard>
  );
}
